import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NumericInput } from '@dnhb/numeric-input';
import { InputContainer, Errors } from './';
import EuroSvg from 'images/shared/euro.svg';

const Input = styled(NumericInput)`
    padding-left: 30px !important;
    margin-bottom: 10px;
`;

const iconSize = '12px'
const Prefix = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  display: flex;
  align-items: center;
  
  padding: 0 8px 0 10px;

  pointer-events: none;

  svg {
    display: block;
    height: ${iconSize};
    width: ${iconSize};
    fill: ${props => {
      if (props.disabled) return props.theme.disabledFontColor;
      if (props.errors) return props.theme.errorColor;
      return props.theme.primaryColor;
    }};
  }
`;

const CurrencyInput = ({
  errors = null,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  onClick = () => {},
  ...props
}) => (
  <InputContainer errors={errors} disabled={props.disabled} maxWidth={props.maxWidth} {...props}>
    <Input
      {...props}
      value={props.disabled ? null : Number(props.value)}
      placeholder={props.disabled ? '' : props.placeholder}
      onChange={(e) => {
        // override the value prop on target to a number for backwards compatibility
        return onChange({
          target: {
            name: props.name,
            value: Number.isNaN(e.target.valueAsNumber)
              ? null
              : e.target.valueAsNumber
          }});
      }}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={onClick}
    />
    <Prefix errors={errors} disabled={props.disabled}>
      <EuroSvg />
    </Prefix>
    <Errors errors={errors} />
  </InputContainer>
);

CurrencyInput.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  decimals: PropTypes.number,
  maxWidth: PropTypes.string,
};

CurrencyInput.defaultProps = {
  id: null,
  placeholder: '',
  name: null,
  disabled: false,
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  onClick: () => {},
  value: null,
  errors: null,
  decimals: 2,
  maxWidth: '100%',
};

export default CurrencyInput;
